<template>
  <div :style="chartStyle">
    <template v-if="dataAvailable">
      <div class="closed-only-graph">
        <e-chart :option="closedDataOptions" :autoresize="true" ref="chart"></e-chart>
      </div>
      <div class="material-weights-graph">
        <e-chart :option="materialWeightsGraphOptions" :autoresize="true" ref="chart"></e-chart>
      </div>
    </template>
    <div v-else>
      <p>{{ $t('reporting.industry.noData') }}</p>
    </div>
  </div>
</template>

<script>
import stringUtils from '@/components/mixins/stringUtils'

export default {
  name: 'MaterialWeightsGraph',
  props: {
    materialWeightsData: {
      type: Array,
      required: true,
    },
  },
  mixins: [stringUtils],
  computed: {
    formattedWeightData: function () {
      return this.materialWeightsData
        .filter(entry => entry.name != 'closed_only')
        .map(entry => (entry.name == 'total' ? { ...entry, name: this.$t('meta.total') } : entry))
    },
    chartStyle: function () {
      return {
        // 20px bar height + 12px space = 32px in total
        '--chart-height': this.formattedWeightData.length * 32 + 'px',
      }
    },
    dataAvailable: function () {
      return this.formattedWeightData.length !== 0 && this.formattedWeightData.some(data => data.weight_t > 0)
    },
    materialTypes: function () {
      return this.materialWeightsSeries.map(entry => entry.name)
    },
    materialWeightsSeries: function () {
      return this.formattedWeightData.slice().reverse()
    },
    materialWeightsGraphOptions: function () {
      return this.barGraphOptions(this.materialTypes, this.materialWeightsSeries, {
        overflow: 'truncate',
        ellipsis: '...',
      })
    },
    closedDataOptions: function () {
      const closedOnlySeries = this.materialWeightsData.filter(entry => entry.name == 'closed_only')
      return this.barGraphOptions([this.$t('reporting.industry.closedOrders')], closedOnlySeries, { lineHeight: 16 })
    },
  },
  methods: {
    barGraphOptions(yAxisData, seriesData, axisLabel) {
      return {
        xAxis: {
          type: 'value',
          show: false,
        },
        yAxis: {
          type: 'category',
          data: yAxisData,
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: {
            margin: 24,
            fontWeight: 'bold',
            fontSize: 13,
            color: 'black',
            width: 120,
            ...axisLabel,
          },
        },
        grid: {
          top: 0,
          bottom: 0,
          left: '150px',
          width: '50%',
          right: 0,
        },
        series: [
          {
            data: seriesData,
            type: 'bar',
            backgroundStyle: {
              borderRadius: 5,
              color: '#a1a1a1',
            },
            barCategoryGap: 12,
            itemStyle: {
              borderRadius: 5,
              color: '#314053',
            },
            label: {
              show: true,
              formatter: input => {
                const data = input.data
                return `${this.decimal(data.weight_t)} t`
              },
              position: ['60px', '25%'],
              color: '#fff',
              fontWeight: 700,
              fontSize: 12,
              overflow: 'truncate',
            },
            showBackground: true,
          },
        ],
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.material-weights-graph {
  height: var(--chart-height);
}

.closed-only-graph {
  height: 2rem;
  margin-bottom: 1.5rem;
}
</style>
